import ContactsApi from '@api/ContactsApi'

const state = {
  contacts: [],
  contactsError: false,
  contactsLoading: true,
  contactsUserMessage: ''
}

const mutations = {
  BEGIN_LOADING_CONTACTS(state) {
    state.contactsLoading = true
  },
  SET_CONTACTS(state, contacts) {
    state.contacts = contacts
    state.contactsLoading = false
    state.contactsError = false
  },

  SET_CONTACTS_USER_MESSAGE(state, contactsResponse) {
    state.contactsUserMessage = contactsResponse.userMessage
    state.contactsError = true
    state.contactsLoading = false
  },
}

const getters = {
  contacts:
    state => state.contacts,
  contactsError:
    state => state.contactsError,
  contactsLoading:
    state => state.contactsLoading,
  contactsUserMessage:
    state => state.contactsUserMessage
}

const actions = {
  GET_CONTACTS(context, options = {}) {
    context.commit('BEGIN_LOADING_CONTACTS')
    return new ContactsApi()
      .requestContacts({
        parentGroupCk: context.rootGetters['groupSelector/selected'].parentGroupCk,
        groupCk: context.rootGetters['groupSelector/selected'].groupCk,
        isInternalUser: context.rootGetters.isInternalUser
      })
      .then(contacts => {
        if (!Array.isArray(contacts)) { // there was an error or something and they returned an object
          context.commit('SET_CONTACTS_USER_MESSAGE', contacts)
        } else { // there was no error so return an array
          context.commit('SET_CONTACTS', contacts)
        }
      })
      .catch(_ => {
        // todo
      })
  },
}

export const contacts = {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
